import { render, staticRenderFns } from "./Opmessages.vue?vue&type=template&id=10584648&"
import script from "./Opmessages.vue?vue&type=script&lang=js&"
export * from "./Opmessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports